import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const Gallery = () => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGalleries();
  }, []);

  const loadGalleries = async () => {
    try {
      const response = await api.get('/gallery/');
      setGalleries(response.data.results || response.data);
    } catch (error) {
      console.error('Error loading galleries:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-5">Photo Gallery</h1>
      <Row>
        {galleries.map(gallery => (
          <Col key={gallery.id} md={4} className="mb-4">
            <Link to={`/gallery/${gallery.slug}`} style={{ textDecoration: 'none' }}>
              <Card className="gallery-card h-100">
                {gallery.cover_image && (
                  <Card.Img 
                    variant="top" 
                    src={getMediaUrl(gallery.cover_image)} 
                    alt={gallery.title}
                    style={{ height: '250px', objectFit: 'cover' }}
                  />
                )}
                <Card.Body>
                  <Card.Title>{gallery.title}</Card.Title>
                  <Card.Text>{gallery.description}</Card.Text>
                  <Card.Text className="text-muted small">
                    {moment(gallery.created_date).format('MMMM DD, YYYY')} • {gallery.images_count} Photos
                  </Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Gallery;
